export default __webpack_public_path__ + "static/characters_08_OBertha0-f50802a1ace73465c343cbb0de3d04f3.png";